module.exports = __webpack_public_path__ + "static/media/290675.84da660b.png";